const passports = {
	title: "API Client",
	view_passport: "View API Client: {name}",
	name: "Name",
	client_id: "Client ID",
	client_secret: "Client Secret",
	create_new_key: "Create new API key",
	revoked: "Revoke",
	revoked_success: "API key successfully revoked.",
	revoked_confirm: "Are you sure you want to revoke the selected API client key?",
	test: "Test API",
	api_endpoints: "API Endpoints",
	api: "API",
	login_title: "Login",
	login: "Login",
	headers: "Request Headers",
	auth_token: "Authorization Token",
	generate_auth_token: "Generate authorization token",
	execute: "Execute",
	type: "Type",
	value: "Value",
	method: "Method",
	url: "URL",
};
export default passports;